import React from 'react';
import { CostPerBlockFeature, ConcurrentCCRFeature } from './SharedApiFeatures';
import CheckOrCross from '../Shared/CheckOrCross';

const FEATURE_NAME = 'stt-async';

const sttBatchFeatures = ({ packages, sttConfig }) => ({
  enabled: {
    key: 'stt-batch-enabled',
    label: 'sttBatch',
    values: packages.map((pkg) => (
      <CheckOrCross
        key={pkg.code}
        isCheck={!!pkg?.features?.includes(FEATURE_NAME)}
      />
    )),
  },
  costPerBlock: {
    key: 'stt-batch-cost-per-block',
    label: 'costPerBlock',
    values: packages.map((pkg) => (
      <CostPerBlockFeature
        key={pkg.code}
        pkg={pkg}
        creditPerBlock={sttConfig?.creditPerBlock}
        featureName="stt-async"
      />
    )),
  },
  concurrentCCR: {
    key: 'stt-batch-ccr',
    label: 'concurrentAPIRequests',
    values: packages.map((pkg) => (
      <ConcurrentCCRFeature
        key={pkg.code}
        pkg={pkg}
        ccr={pkg?.apiCcr?.stt?.async}
      />
    )),
  },
});

export default sttBatchFeatures;
